var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFundingSourceSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/wallet-add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet-add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.2617 15.9385H9.26172",
    stroke: "#FFC051",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.7617 13.498V18.498",
    stroke: "#FFC051",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.66 3.01814L12.63 3.08814L9.72996 9.81814H6.87996C6.19996 9.81814 5.54996 9.95814 4.95996 10.2081L6.70996 6.02814L6.74996 5.92814L6.81996 5.76814C6.83996 5.70814 6.85996 5.64814 6.88996 5.59814C8.19996 2.56814 9.67996 1.87814 12.66 3.01814Z",
    stroke: "#FFC051",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.0505 10.0182C17.6005 9.87819 17.1205 9.81819 16.6405 9.81819H9.73047L12.6305 3.08819L12.6605 3.01819C12.8105 3.06819 12.9505 3.13819 13.1005 3.19819L15.3105 4.12819C16.5405 4.63819 17.4005 5.16819 17.9205 5.80819C18.0205 5.92819 18.1005 6.03819 18.1705 6.16819C18.2605 6.30819 18.3305 6.44819 18.3705 6.59819C18.4105 6.68819 18.4405 6.77819 18.4605 6.85819C18.7305 7.69819 18.5705 8.72819 18.0505 10.0182Z",
    stroke: "#FFC051",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.5217 14.6984V16.6484C21.5217 16.8484 21.5117 17.0484 21.5017 17.2484C21.3117 20.7384 19.3617 22.4984 15.6617 22.4984H7.86172C7.62172 22.4984 7.38172 22.4784 7.15172 22.4484C3.97172 22.2384 2.27172 20.5384 2.06172 17.3584C2.03172 17.1284 2.01172 16.8884 2.01172 16.6484V14.6984C2.01172 12.6884 3.23172 10.9584 4.97172 10.2084C5.57172 9.95836 6.21172 9.81836 6.89172 9.81836H16.6517C17.1417 9.81836 17.6217 9.88836 18.0617 10.0184C20.0517 10.6284 21.5217 12.4884 21.5217 14.6984Z",
    stroke: "#FFC051",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.71 6.02808L4.96 10.2081C3.22 10.9581 2 12.6881 2 14.6981V11.7681C2 8.92808 4.02 6.55808 6.71 6.02808Z",
    stroke: "#FFC051",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M21.5186 11.7677V14.6977C21.5186 12.4977 20.0586 10.6277 18.0586 10.0277C18.5786 8.72766 18.7286 7.70766 18.4786 6.85766C18.4586 6.76766 18.4286 6.67766 18.3886 6.59766C20.2486 7.55766 21.5186 9.52766 21.5186 11.7677Z",
    stroke: "#FFC051",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundingSourceSvg);
export default __webpack_public_path__ + "static/media/FundingSourceSvg.7344947e6fd2509a23030689b8f64274.svg";
export { ForwardRef as ReactComponent };